





































































































import { Component, Prop, Vue, Provide, Watch } from "vue-property-decorator";
import Step from "@/components/Step.vue";
import dayjs from "dayjs";

interface DictObj {
  [key: string]: any;
}
interface ContainsDictObj {
  [key: string]: boolean;
}

@Component({
  components: {
    Step,
  },
})
export default class TreeViewInteractive extends Vue {
  @Provide("$api") $api: any;

  @Prop() private tree!: string;
  @Prop() private decisionId!: string;
  @Prop() private decisionName!: string;

  private treeNotFound = false;
  private description = "";
  private steps: Array<any> = [];
  private parameters: Array<any> = [];
  private taxcodesList: Array<string> = [];
  private taxcodesDict = {};
  private taxCodesLeft: ContainsDictObj = {};
  private taxCodesLoading = true;
  private parametersLoading = true;
  private showTaxability = false;
  private taxabilityMatrix: DictObj = {};
  private search: Array<string> = [];
  private taxabilityLoading = true;
  private taxabilityOnlyActive = false;
  private taxabilityDialogShown = false;

  @Watch("tree")
  getTree() {
    if (this.tree) {
      this.$store.commit("startLoading");
      this.$api
        .get("api/tree/" + this.tree)
        .then((response: any) => {
          const treeDetails = response.data;
          this.description = treeDetails["name"];
          this.parameters = treeDetails["parameters"];
          this.taxcodesList = treeDetails["taxcodes"];
          this.$api
            .post("api/taxcodes/", this.taxcodesList)
            .then((response: any) => {
              const result = response.data;
              result.sort((a: any, b: any) =>
                a.code < b.code ? -1 : a.code > b.code ? 1 : 0
              );
              result.forEach((taxcode: any) => {
                this.$store.commit("setTaxcode", {
                  code: taxcode.code,
                  description: taxcode.description,
                  additionalDescription: taxcode.additionalDescription,
                  effectiveFrom: taxcode.effectiveFrom,
                });
              });
              result.forEach((taxcode: any) => {
                this.$set(this.taxcodesDict, taxcode.code, taxcode.description);
              });
            })
            .finally(() => {
              this.$store.commit("stopLoading");
              this.taxCodesLoading = false;
            });
          if (this.decisionId) {
            this.$store.commit("startLoading");
            this.$api
              .post("api/decision/" + this.decisionId)
              .then((response: any) => {
                const stepResult = response.data[0];
                this.getNextTaxCodes(stepResult);
                this.steps.push(stepResult);
                this.$store.commit("stopLoading");
              });
          } else {
            this.$store.commit("startLoading");
            this.$api
              .post(
                "api/next-step/",
                {},
                {
                  params: {
                    /* eslint-disable @typescript-eslint/camelcase */
                    node_name: this.description,
                    node_type: "Tree",
                  },
                }
              )
              .then((response: any) => {
                const stepResult = response.data[0];
                this.getNextTaxCodes(stepResult);
                this.steps.push(stepResult);
                this.$store.commit("stopLoading");
              });
          }
        })
        .catch((error) => {
          this.$store.commit("stopLoading");
          this.$store.commit(
            "recordError",
            `Session for ${this.tree} not found. Try reloading the page`
          );

          this.treeNotFound = true;
        });
    }
  }

  restart() {
    this.steps = [];
    this.getTree();
  }

  getNext(r: any, answers: any, id: number, displayName?: any) {
    this.$store.commit("startLoading");
    this.steps.splice(id + 1);
    this.$api
      .post("api/next-step/", answers, {
        params: { node_name: r.name, node_id: r.decisionId },
      })
      .then((response: any) => {
        const stepResult = response.data[0];
        this.getNextTaxCodes(stepResult);
        this.steps.push(stepResult);
        this.$store.commit("stopLoading");
      });
    const answer = Object.values(answers)[0];
    (this.$parent as any).captureInteractiveSession(
      r.question,
      displayName || answer,
      this.description
    );
  }

  @Watch("description")
  captureTreeName() {
    if (this.description.length > 0)
      (this.$parent as any).captureInteractivePageLoad(this.description);
  }

  onUseThis(code, description) {
    const taxcodeDetail = {
      code,
      desc: description,
      /* eslint-disable @typescript-eslint/camelcase */
      short_desc: description,
    };
    window.parent.postMessage(JSON.stringify(taxcodeDetail), "*");
  }

  getNextTaxCodes(r: any) {
    if (r.value) {
      this.taxCodesLeft = { [r.value]: true };
      return;
    }
    this.$store.commit("startLoading");
    this.$api
      .get("api/decision/" + r.decisionId + "/taxcodes/")
      .then((response: any) => {
        this.taxCodesLeft = {};
        for (const t in response.data) {
          this.taxCodesLeft[response.data[t]] = true;
        }
        this.$store.commit("stopLoading");
      });
  }

  get widget() {
    return this.$store.state.widget;
  }

  mounted() {
    this.getTree();
  }

  reload() {
    setTimeout(() => {
      window.location.reload(true);
    }, 1000);
  }

  private newTaxcodeText(date) {
    return (
      "New tax code! Code will be active from " +
      dayjs(date).format("D MMM, YYYY")
    );
  }

  private isNewTaxcode(effFrom) {
    return dayjs(effFrom).isAfter(dayjs(new Date()));
  }

  effectiveFrom(taxcode: string) {
    return this.$store.getters.taxcode(taxcode)?.effectiveFrom;
  }
}
